import { del, get, post, put } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"

export const getPageDefinitions = () => get(url.PAGE_DEFINITIONS)
export const addNewPageDefinition = pageDefinition => post(url.PAGE_INSERT, pageDefinition)
export const updatePageDefinition = pageDefinition => put(url.PAGE_UPDATE, pageDefinition)
export const deletePageDefinition = guid => del(url.PAGE_DELETE, { params: { guid } })